import { Injectable, Component } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { DataAccessService } from '../../shared/services/dataaccess.service';
import { Configuration, BaseClass } from './../../app.constants';
import { CurrentBasicCourse } from 'src/app/scholarship/services/scholarshipregistrtion.service';
import number_box from 'devextreme/ui/number_box';


export class CourseProduct {
  CourseID: number;
  CourseName: string;
}


export class CourseWiseExam {
  CourseId: number;
  Id: number;
  Semister: string;
  Subject: string;
  PassingYear: string;
  Status: string;
  IsChecked: boolean;
  CourseName: string;
}

let courseWiseExam: CourseWiseExam[] = [{
  CourseId: 1,
  Id: 1,
  Semister: "Semister 1",
  Subject: "Statistics",
  PassingYear: "2016-2017",
  Status: "Pass",
  IsChecked: true,
  CourseName: "Commerce"
}, {
  CourseId: 1,
  Id: 2,
  Semister: "Semister 1",
  Subject: "Accounts",
  PassingYear: "2016-2017",
  Status: "Pass",
  IsChecked: true,
  CourseName: "Commerce"
},
{
  CourseId: 1,
  Id: 3,
  Semister: "Semister 1",
  Subject: "Economics",
  PassingYear: "2016-2017",
  Status: "Pass",
  IsChecked: true,
  CourseName: "Commerce"
}, {
  CourseId: 1,
  Id: 4,
  Semister: "Semister 1",
  Subject: "Business Law",
  PassingYear: "2016-2017",
  Status: "Pass",
  IsChecked: false,
  CourseName: "Commerce"
}, {
  CourseId: 1,
  Id: 5,
  Semister: "Semister 1",
  Subject: "Seceratial Practice",
  PassingYear: "2016-2017",
  Status: "Pass",
  IsChecked: true,
  CourseName: "Commerce"
},
{
  CourseId: 2,
  Id: 6,
  Semister: "Semister 1",
  Subject: "Statistics",
  PassingYear: "2016-2017",
  Status: "Pass",
  IsChecked: true,
  CourseName: "Arts"
}, {
  CourseId: 2,
  Id: 7,
  Semister: "Semister 1",
  Subject: "History",
  PassingYear: "2016-2017",
  Status: "Pass",
  IsChecked: true,
  CourseName: "Arts"
},
{
  CourseId: 2,
  Id: 8,
  Semister: "Semister 1",
  Subject: "English",
  PassingYear: "2016-2017",
  Status: "Pass",
  IsChecked: true,
  CourseName: "Arts"
}, {
  CourseId: 2,
  Id: 9,
  Semister: "Semister 1",
  Subject: "Geo Law",
  PassingYear: "2016-2017",
  Status: "Pass",
  IsChecked: false,
  CourseName: "Arts"
}, {
  CourseId: 2,
  Id: 10,
  Semister: "Semister 1",
  Subject: "English",
  PassingYear: "2016-2017",
  Status: "Pass",
  IsChecked: true,
  CourseName: "Arts"
}];

export class PreStudentEnrolmentSubjectList extends BaseClass {
  EnrolmentSubjectID: number;
  StudentExamID: number;
  CoursePartID: number;
  BranchID: number;
  SyllabusID: number;
  SubjectID: number;
  CategoryID: number;
  PaperID: number;
  SectionID: number;
  ExamCentreCollegeID: number;
  FreshRepeaterFlag: boolean;
  SubjectStatusFlag: boolean;
  SubjectUniversityCode: string;
  CoursePartDescription: string;
  CoursePartShortName: string;
  SubjectName: string;
  PartSeq: string;
  MaxNoOfSubjects: number;
  MinNoOfSubjects: number;
  SyllabusGroupName: string;
  GroupMaxItem: number;
  GroupMinimumItem: number;
  GroupOrSubjectFlag: string;
  GroupCompulsaryFlag: string;
  SubjectCompulsoryOptionalFlag: string;
  SyllabusGroupID: number;
  IsChecked: boolean;
  IsDisabled: boolean;
  rowId: number;
  Appear: string;
  SyllabusGroupName1: string;
  GroupCompulsaryFlag1: string;
  StudentEnrolmentID: number;
  MainSyllabusGroupID: number;
  SequenceNo: number;
  SubjectTotalCredits: string;
  MaxSequenceNo: number;
}




export class PreExamFormStudent extends BaseClass {
  PreStudentEnrolmentSubjectList: PreStudentEnrolmentSubjectList[];
  EnrolementBranchSelectionList: EnrolementBranchSelectionList[];
  StudentExamID: number;
  ExamApplicationNo: number;
  EnrolmentDate: string;
  StudentID: number;
  CoursePartID: number;
  BranchID: number;
  ExamInstanceID: number;
  CollegeID: number;
  ExamGroup: string;
  AreaofLocationId: number;
  StudentResult: number;
  StudentActivityID: number;
  ImprovementFlag: string;
  RedegreeFlag: string;
  AttendanceYesNo: string;
  AttendancePercentage: number;
  DebarID: number;
  CertificateNo: number;
  ApproveFlag: string;
  ApprovalDateDesc: string;
  ApprovalRemark: string;
  FormPosting: any;
  PhysicalDisabilityID: number;
  ChkListFlag: string;
  TotalFeeAmount: number;
  PaymentRefNo: string;
  PaymentDate: string;
  PaidAmount: number;
  SeatNo: number;
  StudyCentreID: number;
  LateFeeType: number;
  LateFeeAmount: number;
  ChallanNo: string;
  ChallanDate: string;
  OnLinePaymentConfirmFlag: string;
  OnLinePaymentConfirmDate: string;
  OnLinePaymentTransactionID: string;
  ReceiptNo: string;
  RegBankID: number;
  ReceiptDate: string;
  FASRefNo: number;
  AxisBankID: number;
  COMPSERVTRANSID: number;
  RepeaterFLAG: string;
  ReDegreeID: number;
  RBAID: number;
  StudentSeatNO: number;
  PRNNO: string;
  StudentName: string;
  StudentSexCode: string;
  CollegeName1: string;
  CenterName: string;
  CenterShortName: string;
  CourseName: string;
  CoursePatternName: string;
  CoursePartDescription: string;
  BranchName: string;
  ExamInstanceRemark: string;
  ExamCentreCollegeID: number;
  Subjects: any;
  CourseID: number;
  CoursePatternID: number;
  SubjectName: string;
  SubjectShortName: string;
  SubjectUniversityCode: string;
  TotalNoOfStudent: number;
  Range: any;
  TotalCount: number;
  StudentTitle: string;
  StudentFirstName: string;
  StudentLastName: string;
  StudentFatherName: string;
  StudentMothersName: string;
  StudentSeatNo: number;
  StudentPhoto: string;
  StudentSign: string;
  COESign: string;
  AuthorityName: string;
  Designation: number;
  CoursePartShortName: string;
  ExamStartDateTime: string;
  ExamEndDateTime: string;
  ExamSessionFlag: string;
  CollegeCode: string;
  SubjectID: number;
  CategoryName: string;
  CategoryShortName: string;
  TypeFlag: string;
  LocationID: number;
  ApprovalDate: string;
  PGBankRef: any;
  AccountTranRef: any;
  FormCancelFlag: string;
  FormCancelDate: string;
  Gender: string;
  CollegeCityName: string;
  FatherFirstName: string;
  ConsiderationName: string;
  PhysicalDisabilityName: string;
  ReligionDescription: string;
  CasteDescription: string;
  SubCasteDescription: string;
  CollegeName: string;
  UniversityName: string;
  StudentExamCenterName: string;
  ReservationCategoryName: string;
  ApproveFlagDesc: string;
  PhotoPath: string;
  SignPath: string;
  IsSubjectRequired: number;
  ReservationCategoryID: number;
  RegularFeeAmount: number;
  TotalFeesAmount: number;
  StudentType: any;
  FeeAmount: number;
  TotalAmount: number;
  CollegeAmount: number;
  UniversityAmount: number;
  DDNumber: string;
  DDDate: string;
  StudentEnrolmentID: number;
  PaymentType: string;
  FeesID: number;
  payModeID: number;
  customerName: string;
  customerEmailId: string;
  customerMobileNo: number;
  OnlinePaymentID: number;
  merchantTxnNo: number;
  customerID: number;
  PurposeCode: number;
  PrevExam1Obtain: number;
  PrevExam1OutOff: number;
  PrevExam2Obtain: number;
  PrevExam2OutOff: number;
  PrevExam1SpecObtain: number;
  PrevExam1SpecOutOff: number;
  PrevExam2SpecObtain: number;
  PrevExam2SpecOutOff: number;
  PrevExamMarksSheet: string;
  PrevExamMarksSheet2: string;
  AllotmentDocumentPath: string;
  PrevAdmReceipt: string;
  AllowToRemoveCompSubject: string;
  SubjectCreditLimit: number;
  ApplyForDiploma: string;
}
export class EnrolementBranchSelectionList {
  BranchID: number;
  BranchName: number;
}
export class BasicCourse {
  CourseID: number;
  CourseName: string;
}
export class BasicCollege {
  CollegeID: number;
  CollegeName1: string;
  CollegeName: string;
  CoursePartID: number;
}

export class University {
  UniversityID: number;
  UniversityName: string;
}
export class BasicCoursePart {
  CoursePartID: number;
  CoursePartDescription: string;
  BranchApplyFlag: string;
  CoursePartPartNo: number;
}
export class BasicSubject {
  EntSubjectID: number;
  SubjectName: string;
  StudentID: number;
  OutOfMark: number;
  ObtMark: number;
  Percentage: number;
  SubjectID: number;
}
export class SubjectDetail {
  EnrolmentSubjectID: number;
  StudentExamID: number;
  CoursePartID: number;
  BranchID: number;
  SyllabusID: number;
  SubjectID: number;
  CategoryID: number;
  PaperID: number;
  SectionID: number;
  ExamCentreCollegeID: number;
  FreshRepeaterFlag: string;
  SubjectStatusFlag: string;
  CreatedLoginID: number;
  UpdatedLoginID: number;

}

export class PostExamFormStudent {
  TotalFeeAmount: number;
  LateFeeAmount: number;
  UpdatedLoginID: number;
  StudentExamID: number;
  StudentID: number;
  CourseID: number;
  CoursePartID: number;
  BranchID: number;
  subjectDetail: SubjectDetail[];
  PreStudentEnrolmentSubjectList: SubjectDetail[];
  ExamApplicationDate: string;
  ImprovementFlag: string;
  RedegreeFlag: string;
  PhysicalDisabilityID: number;
  SeatNo: number;
  ReservationCategoryID: number;
  StudentType: string;
  FreshRepeaterFlag: string;
  CreatedLoginID: number;
  AcademicInstanceID: number;
  CollegeID: number;
  EnrolmentDate: string;
  EntryFlag: string;
  FeeAmount: number;
  TotalAmount: number;
  CollegeAmount: number;
  UniversityAmount: number;
  TotalFeesAmount: number;
  DDNumber: string;
  DDDate: string;
  ExamInstanceID: number;
  StudentEnrolmentID: number;
  PaymentType: string;
  FeesID: number;
  ReceiptNo: string;
  ReceiptDate: string;
  PrevExam1Obtain: number;
  PrevExam1OutOff: number;
  PrevExam2Obtain: number;
  PrevExam2OutOff: number;
  PrevExam1SpecObtain: number;
  PrevExam1SpecOutOff: number;
  PrevExam2SpecObtain: number;
  PrevExam2SpecOutOff: number;
  PrevExamMarksSheet: string;
  PrevExamMarksSheet2: string;
  PrevAdmReceipt: string;
}
export class PostExamFormStudentAllot {
  PreStudentAllotmentID: number;
  StudentID: number;
  CourseID: number;
  CourseName: string;
  CollegeID: number;
  CoursePartID: number;
  BranchID: number;
  ApplicationFormNo: string;
  UniversityId: number;
  UniversityID: number;
  QuotaType: string;
  RoundNo: number;
  ReservationCategoryID: number;
  SpecialReservationCategoryID: number;
  MinorityType: string;
  AllottedReservationCategoryID: number;
  WeightagePoints: number;
  AcademicInstanceID: number;
  Percentage: number;
  EntranceExam: string;
  EntranceExamPercentile: number;
  TotalPoints: number;
  AllotmentDate: string;
  AllotmentDocumentPath: string;
  MinorityID: number;
  QuotaTypeID: number;
  BasicSubjectList: BasicSubject[];
}


export class BasicCollegeCourse {
  CourseID: number;
  CourseName: string;
}

export class StudentCounsellingPortal {
  StudentID: number;
  PRNNO: string;
  CourseName: string;
  BranchName: string;
  CoursePatternName: string;
  Counselling: string;
}

export class BasicPGGroupType {
  GroupID: number;
  GroupName: string;
  IsMajor: string;
  BranchORSubjectApplicable: string;


}

export class PreStudentCounselling {
  StudentCounsellingID: number;
  StudentID: number;
  AcademicInstanceID: number;
  CourseID: number;
  BranchID: number;
  DeleteFlag: string
  CreatedLoginID: number;
 // CreatedDate: Date;
  UpdatedLoginID: number;
 //UpdatedDate: Date;
  CourseName: string;
  CoursePartDescription: string;
  BranchName: string;
  CoursePartID : number;
  PreStudentCounsellingSubjectList: PreStudentCounsellingSubjectList[];
}
export class PreStudentCounsellingSubjectList {
  StudentCounsellingSubjectID: number;
  StudentCounsellingID: number;
  SubjectMasterID: number;
  GroupID: number;
  DeleteFlag: string;
  CreatedLoginID: number;
  CreatedDate: Date;
  UpdatedLoginID: number;
  UpdatedDate: Date;
  SubjectUniversityCode: string;
  SubjectName: string;
  GroupName: string;
  Credit1: number;
  Credit2: number;
  TotalCredit: number;
  CoursePartID: number;
  CoursePartDescription: string;
}
export class PreStudentCounsellingData{
  SubjectName: string;
}
@Injectable()
export class EnrolmentFormService {
  constructor(private http: HttpClient, private dataService: DataAccessService,
    private configuration: Configuration) {
  }
  getCourseProducts() {
    this.dataService.setControllerName = '/ExamForm/';
    this.dataService.setMethodName = 'GetCourseBranchDetailsForExamForm?StudentID=' + this.configuration.StudentID; // setting method name from API controller
    return this.dataService.getAll<CourseProduct[]>();
  }
  getCourseWiseExam(courseId: number) {
    this.dataService.setControllerName = '/ExamForm/';
    this.dataService.setMethodName = 'GetExamFormDataByPrnNoByStudentIDForPortal?StudentID=' + this.configuration.StudentID + '&CourseID=' + courseId; // setting method name from API controller
    return this.dataService.getAll<PreExamFormStudent>();
  }
  public save(data) {
    this.dataService.setControllerName = '/PreStudentEnrolment/';
    this.dataService.setMethodName = 'PostInsertPreStudentEnrolment'; // setting method name from API controller.
    return this.dataService.add<PostExamFormStudent>(data)
  }
  public PostInsertPreStudentAllotment(data) {
    this.dataService.setControllerName = '/PreStudentAllotment/';
    this.dataService.setMethodName = 'PostInsertPreStudentAllotment';
    return this.dataService.add<PostExamFormStudentAllot>(data)
  }
  public PostPreStudentAllotment(data) {
    this.dataService.setControllerName = '/PreStudentAllotment/';
    this.dataService.setMethodName = 'PostPreStudentAllotment';
    return this.dataService.add<PostExamFormStudentAllot>(data)
  }
  public saveexternal(data) {
    this.dataService.setControllerName = '/PreStudentEnrolment/';
    this.dataService.setMethodName = 'PostInsertPreStudentEnrolmentExternal'; // setting method name from API controller.
    return this.dataService.add<PostExamFormStudent>(data)
  }
  public update(data) {
    debugger
    this.dataService.setControllerName = '/PreStudentEnrolment/';
    this.dataService.setMethodName = 'PostPreStudentEnrolment'; // setting method name from API controller.
    return this.dataService.add<PostExamFormStudent>(data)
  }

  GetExamFormListForPortal() {
    this.dataService.setControllerName = '/ExamForm/';
    this.dataService.setMethodName = 'GetExamFormListForPortal?StudentID=' + this.configuration.StudentID; // setting method name from API controller
    return this.dataService.getAll<PreExamFormStudent>();
  }

  GetCheckPRNNoPresent() {
    this.dataService.setControllerName = '/ExamForm/';
    this.dataService.setMethodName = 'GetCheckPRNNoPresent?PRNNO=' + this.configuration.PRNNo + '&ExamInstID=' + this.configuration.ExamInstanceID; // setting method name from API controller
    return this.dataService.getAll<PreExamFormStudent>();
  }

  GetExamFormsByID(StudentExamID) {
    this.dataService.setControllerName = '/ExamForm/';
    this.dataService.setMethodName = 'GetExamFormsByID?StudentExamID=' + StudentExamID; // setting method name from API controller
    return this.dataService.getAll<PreExamFormStudent>();
  }

  GetCheckScheduleAndGetFees(ExamInstID, CoursePartID, BranchID) {
    debugger
    this.dataService.setControllerName = '/ExamForm/';
    this.dataService.setMethodName = 'GetCheckScheduleAndGetFees?ExamInstID=' + ExamInstID + '&CoursePartID=' + CoursePartID + '&BranchID=' + BranchID;
    return this.dataService.getAll<PreExamFormStudent>();
  }

  GetExamFormPrint(StudentID, CourseID, BranchID, CoursePartID, CollegeID, AcademicInstanceID) {
    debugger
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetStudentEnorollmentFormReportByStudentID?StudentID=' + StudentID + '&CourseID=' + CourseID + '&BranchID=' + BranchID + '&CoursePartID=' + CoursePartID + '&CollegeID=' + CollegeID + '&AcademicInstanceID=' + AcademicInstanceID + '';
    return this.dataService.getAll<PreExamFormStudent>();
  }

  GetEligibleCourseForEnrolment(StudentID, ExamInstanceID, AcademicInstanceID) {
    this.dataService.setControllerName = '/PreStudentEnrolment/';
    this.dataService.setMethodName = 'GetEligibleCourseForEnrolment?StudentID=' + StudentID + '&ExamInstanceID=' + ExamInstanceID + '&AcademicInstanceID=' + AcademicInstanceID + '';
    return this.dataService.getAll<PreExamFormStudent>();
  }
  GetEligibleCourseForEnrolmentForAllotment(StudentID, ExamInstanceID, AcademicInstanceID) {
    this.dataService.setControllerName = '/PreStudentAllotment/';
    this.dataService.setMethodName = 'GetEligibleCourseForEnrolmentForAllotment?StudentID=' + StudentID + '&ExamInstanceID=' + ExamInstanceID + '&AcademicInstanceID=' + AcademicInstanceID + '';
    return this.dataService.getAll<PostExamFormStudentAllot>();
  }
  GetBasicCollegeList(CollegeID) {
    this.dataService.setControllerName = '/BasicCollege/';
    this.dataService.setMethodName = 'GetBasicCollegeList?CollegeID=' + CollegeID + '';
    return this.dataService.getAll<BasicCollege>();
  }
  GetBasicCollegeCourseList(CollegeID) {
    this.dataService.setControllerName = '/BasicCollegeCourse/';
    this.dataService.setMethodName = 'GetBasicCollegesCoursesListByCourseIDCollegeID?CourseID=0&CollegeID=' + CollegeID + '';
    return this.dataService.getAll<BasicCollege>();
  }
  public GetBasicUniversityListByState(StateID) {
    this.dataService.setControllerName = '/BasicState/';
    this.dataService.setMethodName = 'GetBasicUniversityListByState?StateID=' + StateID + ''; // setting method name from API controller.
    return this.dataService.getAll<University[]>()
  }
  GetEligibleCourseForEnrolmentForExternal(StudentID, ExamInstanceID, AcademicInstanceID) {
    this.dataService.setControllerName = '/PreStudentEnrolment/';
    this.dataService.setMethodName = 'GetEligibleCourseForEnrolmentForExternal?StudentID=' + StudentID + '&ExamInstanceID=' + ExamInstanceID + '&AcademicInstanceID=' + AcademicInstanceID + '';
    return this.dataService.getAll<PreExamFormStudent>();
  }
  GetPreStudentEnrolmentByPrnNoForEnrollment(PRNNO, ExamInstID, CollegeID, CoursePartID, BranchID, AcademicInstanceID, CourseID) {
    this.dataService.setControllerName = '/PreStudentEnrolment/';
    this.dataService.setMethodName = 'GetPreStudentEnrolmentByPrnNoForEnrollment?PRNNO=' + PRNNO + '&ExamInstID=' + ExamInstID + '&CollegeID=' + CollegeID + '&CoursePartID=' + CoursePartID + '&BranchID=' + BranchID + '&AcademicInstanceID=' + AcademicInstanceID + '&CourseID=' + CourseID;
    return this.dataService.getAll<PreExamFormStudent>();
  }

  GetCheckScheduleAndGetFeesForEnrollment(CoursePartID, AcdYrID, BranchID, StudentType) {
    debugger
    this.dataService.setControllerName = '/PreStudentEnrolment/';
    this.dataService.setMethodName = 'GetCheckScheduleAndGetFeesForEnrollment?CoursePartID=' + CoursePartID + '&BranchID=' + BranchID + '&AcademicInstanceID=' + AcdYrID + '&StudentType=' + StudentType;
    return this.dataService.getAll<PreExamFormStudent>();
  }
  GetScheduleFeesCheckForEnrolment(CollegeID, AcdYrID, CourseID, CoursePartID, BranchID, EnrolmentScheduleID) {
    debugger
    this.dataService.setControllerName = '/AcademicInstanceFees/';
    this.dataService.setMethodName = 'GetScheduleFeesCheckForEnrolment?CollegeID=' + CollegeID + '&AcdYrID=' + AcdYrID + '&CourseID=' + CourseID + '&CoursePartID=' + CoursePartID + '&BranchID=' + BranchID + '&EnrolmentScheduleID=' + EnrolmentScheduleID;
    return this.dataService.getAll<PreExamFormStudent>();
  }


  GetStudentEnrollmentListForPortal(StudentID, CoursePartID, AcademicInstanceID) {
    debugger
    this.dataService.setControllerName = '/PreStudentEnrolment/';
    this.dataService.setMethodName = 'GetStudentEnrollmentListForPortal?StudentID=' + StudentID + '&CoursePartID=' + CoursePartID + '&AcademicInstanceID=' + AcademicInstanceID;
    return this.dataService.getAll<PreExamFormStudent>();
  }

  public GetUpdatePaymentStatusForEnrolmentForm(StudentID, merchantTxnNo, ExamInstanceID, CourseID, CoursePartID, BranchID, CollegeID) {
    debugger
    this.dataService.setControllerName = '/Payment/';
    this.dataService.setMethodName = 'GetUpdatePaymentStatusForEnrolmentForm?StudentID=' + StudentID + '&merchantTxnNo=' + merchantTxnNo + '&ExamInstanceID=' + ExamInstanceID + '&CourseID=' + CourseID + '&CoursePartID=' + CoursePartID + '&BranchID=' + BranchID + '&CollegeID=' + CollegeID; // setting method name from API controller.

    return this.dataService.getAll<PreExamFormStudent[]>()
  }

  public GetEnrolmentUploadedFile(StudentEnrolmentID, StudentID) {
    debugger;
    this.dataService.setControllerName = '/PreStudentEnrolment/';
    this.dataService.setMethodName = 'GetEnrolmentUploadedFile?StudentEnrolmentID=' + StudentEnrolmentID + '&StudentID=' + StudentID;
    return this.dataService.getAll<PreExamFormStudent[]>()
  }

  public deleteUploadedDocument(data: any) {
    this.dataService.setControllerName = '/PreStudentEnrolment/';
    this.dataService.setMethodName = 'PostDeletePreStudentEnrolmentFile'; // setting method name from API controller
    return this.dataService.delete<PreExamFormStudent>(data);
  }
  public GetdeleteUploadedDocumentAllotment(PreStudentAllotmentID, StudentID) {
    this.dataService.setControllerName = '/PreStudentAllotment/';
    this.dataService.setMethodName = 'GetPostDeletePreStudentEnrolmentFileAllotment?PreStudentAllotmentID=' + PreStudentAllotmentID + '&StudentID=' + StudentID + '';
    return this.dataService.getAll<PostExamFormStudentAllot[]>()
  }
  uploadEnrolmentFile(fileToUpload: File, StudentID, StudentEnrolmentID, CertId) {
    debugger
    let formData: FormData = new FormData();

    formData.append('file', fileToUpload, fileToUpload.name);
    var queryParam = "?StudentID=" + StudentID + "&StudentEnrolmentID=" + StudentEnrolmentID + "&CertId=" + CertId + "";
    let apiUrl = this.configuration.serverWithApiUrl + "/PreStudentEnrolment/PostuploadEnrolmentFile" + queryParam;

    return this.http
      .post(apiUrl, formData);
  }
  uploadEnrolmentFileAllotment(fileToUpload: File, StudentID, PreStudentAllotmentID) {
    debugger
    let formData: FormData = new FormData();

    formData.append('file', fileToUpload, fileToUpload.name);
    var queryParam = "?StudentID=" + StudentID + "&PreStudentAllotmentID=" + PreStudentAllotmentID + "";
    let apiUrl = this.configuration.serverWithApiUrl + "/PreStudentEnrolment/PostuploadEnrolmentFileAllotment" + queryParam;

    return this.http
      .post(apiUrl, formData);
  }
  public GetBasicCourseList() {
    this.dataService.setControllerName = '/BasicCourse/';
    this.dataService.setMethodName = 'GetBasicCourseList?CourseID=0';
    return this.dataService.getAll<BasicCourse[]>()
  }
  public GetBasicCoursePartternByCourseID(CourseID) {
    this.dataService.setControllerName = '/BasicCoursePart/';
    this.dataService.setMethodName = 'GetCurrentBasicCoursePartByCourseID?CourseID=' + CourseID + '';
    return this.dataService.getAll<BasicCoursePart[]>()
  }
  public GetBasicBranchList(CourseID) {
    this.dataService.setControllerName = '/BasicCourseBranch/';
    this.dataService.setMethodName = 'GetBasicCourseBranchByCourseID?CourseID=' + CourseID + '';
    return this.dataService.getAll<EnrolementBranchSelectionList[]>()
  }
  public GetMathBioSubjectForAllotment(CourseID, StudentID) {
    this.dataService.setControllerName = '/ExamForm/';
    this.dataService.setMethodName = 'GetMathBioSubjectForAllotment?CourseID=' + CourseID + '&StudentID=' + StudentID + '';
    return this.dataService.getAll<BasicSubject>();
  }

  public GetCoursewiseBranchData(CourseID, StudentID) {
    debugger
    this.dataService.setControllerName = '/ExamForm/';
    this.dataService.setMethodName = 'GetCoursewiseBranchData?CourseID=' + CourseID + '&StudentID=' + StudentID + '';
    return this.dataService.getAll<BasicSubject>();
  }

  // GetBasicCollegesCoursesListByCourseIDNEW(CourseID) {
  //   this.dataService.setControllerName = '/BasicCollegeCourse/';
  //   this.dataService.setMethodName = 'GetBasicCollegesCoursesListByCourseIDNEW?CourseID=' + CourseID + '';
  //   return this.dataService.getAll<BasicCollege>();
  // }
  // GetBasicCoursePartForCollegeDropDownStatus(CourseID) {
  //   this.dataService.setControllerName = '/BasicCollegeCourse/';
  //   this.dataService.setMethodName = 'GetBasicCoursePartForCollegeDropDownStatus?CourseID=' + CourseID + '';
  //   return this.dataService.getAll<BasicCollege>();
  // }




  public GetStudentInformationByStudentIDForStudentCounselling(StudentID) {
    debugger
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetStudentInformationByStudentIDForStudentCounselling?StudentID=' + StudentID + '';
    return this.dataService.getAll<StudentCounsellingPortal>();
  }


  public GetBasicCoursePartByCoursePartternIDForAdmissionForm(CoursePatternID) {
    debugger
    this.dataService.setControllerName = '/BasicCoursePart/';
    this.dataService.setMethodName = 'GetBasicCoursePartByCoursePartternIDForAdmissionForm?CoursePatternID=' + CoursePatternID + '';
    return this.dataService.getAll<BasicCoursePart>();
  }


  public GetBasicPGGroupTypeList() {
    this.dataService.setControllerName = '/BasicPGCourse/';
    this.dataService.setMethodName = 'GetBasicPGGroupTypeList?GroupID=0';
    return this.dataService.getAll<BasicPGGroupType[]>()
  }

  public GetAddSubjectToList(StudentID, AcademicInstanceID, CourseID, BranchID, CoursePartID, SubjectUniversityCode, GroupID) {debugger;
    this.dataService.setControllerName = '/PreStudentCounselling/';
    this.dataService.setMethodName = 'GetAddSubjectToList?StudentID=' + StudentID + '&AcademicInstanceID=' + AcademicInstanceID + '&CourseID=' + CourseID + '&BranchID=' + BranchID + '&CoursePartID=' + CoursePartID + '&SubjectUniversityCode=' + SubjectUniversityCode + '&GroupID=' + GroupID + '';
    return this.dataService.getAll<PreStudentCounselling[]>()
  }


  public GetBasicSubjectByCode(SubjectUniversityCode, CourseID, GroupID, CoursePartID, BranchID) {debugger;
    this.dataService.setControllerName = '/PreStudentCounselling/';
    this.dataService.setMethodName = 'GetBasicSubjectByCode?SubjectUniversityCode=' + SubjectUniversityCode + '&CourseID=' + CourseID + '&GroupID=' + GroupID + '&CoursePartID=' + CoursePartID + '&BranchID=' + BranchID +  '';
    return this.dataService.getAll<BasicSubject[]>()
  }

  public PostInsertPreStudentCounselling(data) {
    this.dataService.setControllerName = '/PreStudentCounselling/';
    this.dataService.setMethodName = 'PostInsertPreStudentCounselling';
    return this.dataService.add<PreStudentCounselling>(data)
  }

  public PostPreStudentCounselling(data) {
    this.dataService.setControllerName = '/PreStudentCounselling/';
    this.dataService.setMethodName = 'PostPreStudentCounselling';
    return this.dataService.update<PreStudentCounselling>(data)
  }


  public PostDeletePreStudentCounselling(data) {
    this.dataService.setControllerName = '/PreStudentCounselling/';
    this.dataService.setMethodName = 'PostDeletePreStudentCounselling';
    return this.dataService.delete<PreStudentCounselling>(data)
  }


  
  public PostDeletePreStudentCounsellingSubject(data) {
    this.dataService.setControllerName = '/PreStudentCounsellingSubject/';
    this.dataService.setMethodName = 'PostDeletePreStudentCounsellingSubject';
    return this.dataService.delete<PreStudentCounselling>(data)
  }
  
  


  public GetPreStudentCounsellingByStudentID(StudentID, AcademicInstanceID, CourseID, BranchID) {
    this.dataService.setControllerName = '/PreStudentCounselling/';
    this.dataService.setMethodName = 'GetPreStudentCounsellingByStudentID?StudentID=' + StudentID + '&AcademicInstanceID=' + AcademicInstanceID + '&CourseID=' + CourseID + '&BranchID=' + BranchID +  '';
    return this.dataService.getAll<PreStudentCounselling[]>()
  }
  // public PreStudentCounsellingData: PreStudentCounsellingData;
  // public GetBasicSubjectByCode(SubjectUniversityCode, CourseID, GroupID, CoursePartID, BranchID) {debugger;
  //   this.dataService.setControllerName = '/PreStudentCounselling/';
  //   this.dataService.setMethodName = 'GetBasicSubjectByCode';
  //   this.dataService
  //     .getSingle<BasicSubject>('?SubjectUniversityCode=' + SubjectUniversityCode + '&CourseID=' + CourseID + '&GroupID=' + GroupID + '&CoursePartID=' + CoursePartID + '&BranchID=' + BranchID +  '')
  //     .subscribe((data: BasicSubject) => this.PreStudentCounsellingData = data,
  //       error => () => {
  //       },
  //       () => {
  //             return this.PreStudentCounsellingData;
  //       });
  // }

}
